import { Body1, Title3, makeStyles, tokens } from "@fluentui/react-components";
import { LockClosed24Regular } from "@fluentui/react-icons";
import { Shell } from "../components/Shell";
import { useData } from "../data/DataProvider";

const useStyles = makeStyles({
  box: { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: tokens.spacingVerticalM, paddingTop: tokens.spacingVerticalXXXL },
  icon: { fontSize: "40px", color: tokens.colorNeutralForeground3 },
});

export function NonAutorizzato() {
  const s = useStyles();
  const { me } = useData();
  return (
    <Shell title="Gare">
      <div className={s.box}>
        <LockClosed24Regular className={s.icon} />
        <Title3>Accesso non abilitato</Title3>
        <Body1>
          Quest'app è riservata a chi gestisce le gare e a chi lavora nelle cartelle di gara. Se pensi di doverla usare, chiedi all'amministratore di aggiungerti come membro al gruppo giusto (Gare Gestori, Gare Collaboratori o Gare Lettori).
        </Body1>
        <Body1>
          Hai effettuato l'accesso come <strong>{me.userPrincipalName}</strong>.
        </Body1>
      </div>
    </Shell>
  );
}
